import { render, staticRenderFns } from "./work-rules.vue?vue&type=template&id=78b1668a&scoped=true"
import script from "./work-rules.vue?vue&type=script&lang=js"
export * from "./work-rules.vue?vue&type=script&lang=js"
import style0 from "./work-rules.vue?vue&type=style&index=0&id=78b1668a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b1668a",
  null
  
)

export default component.exports